import { createSlice } from "@reduxjs/toolkit";
import APPCONFIG from "constants/appConfig";
import axios from "axios";
import { redirectAndSaveState } from "services/auth";

const requestTypes = {
  NEW_VENDOR: "NV",
  CHANGE_VENDOR: "CV",
  EXTEND_VENDOR_THIRDPARTY: "EVT",
  EXTEND_VENDOR_INTERCOMPANY: "EVI",
  REACTIVATE_VENDOR: "RV"
};

const requestStates = {
  CREATE: "VENDOR_MASTER",
  ADJUST: "VENDOR_DETAILS"
};

export const initialState = {
  error: null,
  loading: false,
  loaded: false,
  listvalues: {},
  isResetRequest:false,
  requestTypes,
  requestStates,
  activeRequestType: null,
  activeRequestState: null,
  activeRequestID: null,
  snackbar: { open: false, severity: "info", message: "default" },
  highlightRequiredFields: false
};

export const appdataSlice = createSlice({
  name: "appdata",
  initialState,
  reducers: {
    appdata_clearActive:(state,action) =>{
      state.activeRequestID = null;
    },
    appdata_setError: (state, action) => {
      state.error = action.payload
    },
    appdata_setIsRequestRequest: (state, action) => {
      state.isResetRequest = action.payload
    },
    appdata_setHighlightRequiredFields: (state, action) => {
      state.highlightRequiredFields = action.payload
    },
    appdata_setLoaded: (state, action) => {
      state.loaded = action.payload;
    },
    appdata_setLoading: (state, action) => {
      state.loading = action.payload;
    },
    appdata_setActiveRequestID: (state, action) => {
      state.activeRequestID = action.payload;
    },
    appdata_setLoadedDropdowndata: (state, action) => {
      state.loadedDropdowndata = action.payload;
    },
    appdata_setLoadingDropdowndata: (state, action) => {
      state.loadingDropdowndata = action.payload;
    },
    appdata_setListValues: (state, action) => {
      state.listvalues = action.payload;
    },
    appdata_updateListValues: (state, action) => {
      console.log("update listvalues", action);
      return {
        ...state,
        listvalues: {
          ...state.listvalues,
          [action.payload.key]: action.payload.value
        }
      };
    },
    appata_setDropdowndata: (state, action) => {
      console.log("set app language to ", action.payload);
      state.dropdowndata = action.payload;
    },
    appdata_setActiveRequestType: (state, action) => {
      if (state.activeRequestType != action.payload) {
        state.activeRequestType = action.payload;
      }
    },
    appdata_setActiveRequestState: (state, action) => {
      state.activeRequestState = action.payload;
    },
    appdata_setSnackbar: (state, action) => {
      state.snackbar.severity = action.payload.severity
        ? action.payload.severity
        : "info";
      state.snackbar.message = action.payload.message
        ? action.payload.message
        : "";
      state.snackbar.open = action.payload.open ? action.payload.open : false;
    }
  }
});

export const {
  appdata_setError,
  appdata_setIsRequestRequest,
  appdata_setLoading,
  appdata_setListValues,
  appdata_setLoaded,
  appdata_setActiveRequestType,
  appdata_setActiveRequestState,
  appdata_setSnackbar,
  appdata_updateListValues,
  appdata_setActiveRequestID,
  appdata_setHighlightRequiredFields,
  appdata_clearActive,
} = appdataSlice.actions;
export const appdataSelector = state => state.appdata;
export default appdataSlice.reducer;

// fetch all items
export function fetchAppdata() {
  return async (dispatch, getState) => {
    dispatch(appdata_setLoading(true));

    console.log("go fetchappdata", getState().appdata);
    var param = "";
    if (
      getState().appdata.activeRequestType ==
      getState().appdata.requestTypes.EVI
    ) {
      param = "/EVI";
    }

    axios.defaults.withCredentials = true;
    axios
      .get(APPCONFIG.appBackendHostname + "api/vendormasterdata/structure", {
        withCredentials: true,
        timeout: APPCONFIG.axiosTimeout
      })
      .then(res => {
        console.log("structure received", res);
        console.log(res);
        dispatch(appdata_setListValues(res.data));
        dispatch(appdata_setLoading(false));
        dispatch(appdata_setLoaded(true));

        /* this.setState({
          listvalues: res.data,
          hasLogin: true
        }); */
      })
      .catch(error => {
        // handle error
        console.error(error);
        dispatch(appdata_setError("Get structure: " + error.message));
        redirectAndSaveState(error);
      });
  };
}

export function appdata_getVendorsForCompany(companyId) {
  console.log("get vendors for company");

  return async (dispatch, getState) => {
    dispatch(
      appdata_updateListValues({
        key: "vendorsForCompany",
        value: {}
      })
    );
    if (companyId) {
      axios.defaults.withCredentials = true;
      axios
        .get(
          APPCONFIG.appBackendHostname +
          "api/vendormasterdata/vendorsForCompany/" +
          companyId,
          {
            withCredentials: true,
            timeout: APPCONFIG.axiosTimeout
          }
        )
        .then(res => {
          console.log("got vendorsForCompany", res);
          dispatch(
            appdata_updateListValues({
              key: "vendorsForCompany",
              value: res.data.VENDORS
            })
          );
        })
        .catch(error => {
          console.log(" error on result");
          console.log(error);
        });
    }
  };
}

export function appdata_getPOsForVendor(companyId, vendorId) {
  console.log("appdata_getPOsForVendor", companyId, vendorId);

  return async (dispatch, getState) => {
    dispatch(
      appdata_updateListValues({
        key: "POsForVendor",
        value: {}
      })
    );

    if (companyId && vendorId) {
      axios.defaults.withCredentials = true;
      axios
        .get(
          APPCONFIG.appBackendHostname +
          "api/vendormasterdata/purchasingorganisationsForVendor/" +
          companyId +
          "/" +
          vendorId,
          {
            withCredentials: true,
            timeout: APPCONFIG.axiosTimeout
          }
        )
        .then(res => {
          console.log("got POsForVendor", res);
          dispatch(
            appdata_updateListValues({
              key: "POsForVendor",
              value: res.data.POS
            })
          );
        })
        .catch(error => {
          console.log(" error on result");
          console.log(error);
        });
    }
  };
}

export function appdata_getDeactivatedVendors() {
  console.log("get deactivated vendors for company");

  return async (dispatch, getState) => {
    dispatch(
      appdata_updateListValues({
        key: "deactivatedVendorsForCompany",
        value: {}
      })
    );

    if (getState().vendordata.activeVendor.master.BUKRS || getState().vendordata.activeVendor.master.EKORG) {
      axios.defaults.withCredentials = true;
      axios
        .get(
          APPCONFIG.appBackendHostname +
          "api/vendormasterdata/deactivatedVendors/" +
          getState().vendordata.activeVendor.master.BUKRS
          + "/" +
          getState().vendordata.activeVendor.master.EKORG,
          {
            withCredentials: true,
            timeout: APPCONFIG.axiosTimeout
          }
        )
        .then(res => {
          console.log("got vendorsForCompany", res);
          dispatch(
            appdata_updateListValues({
              key: "deactivatedVendorsForCompany",
              value: res.data.DEACTIVATEDVENDORS
            })
          );
        })
        .catch(error => {
          console.log(" error on result");
          console.log(error);
        });
    }
  };
}

export function appdata_getRegionsForCountry(country) {
  console.log("get deactivated vendors for company");

  return async (dispatch, getState) => {
    dispatch(
      appdata_updateListValues({
        key: "regionsForCountry",
        value: {}
      })
    );
    if (country) {
      axios.defaults.withCredentials = true;
      axios
        .get(
          APPCONFIG.appBackendHostname +
          "api/vendormasterdata/regionsForCountry/" +
          country,
          {
            withCredentials: true,
            timeout: APPCONFIG.axiosTimeout
          }
        )
        .then(res => {
          console.log("got regionsforcountry", res);
          dispatch(
            appdata_updateListValues({
              key: "regionsForCountry",
              value: res.data.REGIONS
            })
          );
        })
        .catch(error => {
          console.log(" error on result");
          console.log(error);
        });
    }
  };
}
